export default __webpack_public_path__ + "static/media/report.1aa4323a.mp4";